var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filing-info"},[_c('div',{staticClass:"filing-text"},[_c('span',{staticClass:"tipsTitle"},[_vm._v("版权所有：逻腾（杭州）科技有限公司")]),_c('a',{staticClass:"recordNumber",attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("浙ICP备19042951号-2")])])])
}]

export { render, staticRenderFns }